export const $ = document.querySelector.bind(document);
export const $$ = document.querySelectorAll.bind(document);
export const isMobile = window.matchMedia('(max-width: 767px)');
export const isNotMobile = window.matchMedia('(min-width: 768px)');
export const isTablet = window.matchMedia('(max-width: 1023px)');
export const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
export const sliderConfig = {
  spaceBetween: 16,
  navigation: {
    prevEl: '[data-au-slider-prev]',
    nextEl: '[data-au-slider-next]',
  },
  scrollbar: {
    el: '[data-au-slider-scrollbar]',
  },
  slidesPerView: 'auto',
  freeMode: true,
  a11y: {
    enabled: true,
    slideRole: null,
  },
};
